/* Black Red - Karussell-Balken, weiches Scrollen, Sets im Menue, Abo/Bundle-Kopplung */
(function () {
  'use strict';

  var registry = [];

  /* ================= 1. Zieh-Balken unter Karussells ================= */
  function initProgress(track) {
    if (!track || track.dataset.brProgress) return;
    if (track.classList.contains('product__media-list')) return;
    if (track.classList.contains('thumbnail-list')) return;

    track.dataset.brProgress = '1';

    var wrap = document.createElement('div');
    wrap.className = 'br-progress br-progress--off';
    var bar = document.createElement('div');
    bar.className = 'br-bar';
    var thumb = document.createElement('div');
    thumb.className = 'br-thumb';
    bar.appendChild(thumb);
    wrap.appendChild(bar);
    track.parentNode.insertBefore(wrap, track.nextSibling);

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var barW = bar.offsetWidth || 160;
      if (max <= 4) {
        wrap.classList.add('br-progress--off');
        return;
      }
      wrap.classList.remove('br-progress--off');
      var ratio = track.clientWidth / track.scrollWidth;
      var tw = Math.max(24, Math.min(barW, Math.round(barW * ratio)));
      thumb.style.width = tw + 'px';
      var p = track.scrollLeft / max;
      thumb.style.transform = 'translateX(' + p * (barW - tw) + 'px)';
    }

    track.addEventListener('scroll', update, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(track);
    }
    registry.push(update);
    requestAnimationFrame(function () { requestAnimationFrame(update); });

    var dragging = false;

    function seek(clientX) {
      var r = bar.getBoundingClientRect();
      var tw = thumb.offsetWidth;
      var span = r.width - tw;
      if (span <= 0) return;
      var p = (clientX - r.left - tw / 2) / span;
      p = Math.min(1, Math.max(0, p));
      track.scrollLeft = p * (track.scrollWidth - track.clientWidth);
    }

    bar.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { bar.setPointerCapture(e.pointerId); } catch (err) {}
      seek(e.clientX);
      e.preventDefault();
    });
    bar.addEventListener('pointermove', function (e) { if (dragging) seek(e.clientX); });
    bar.addEventListener('pointerup', function () { dragging = false; });
    bar.addEventListener('pointercancel', function () { dragging = false; });
  }

  function scanSliders() {
    document.querySelectorAll('.slider, .br-drawer-sets__row').forEach(initProgress);
  }

  function updateAll() {
    registry.forEach(function (fn) { fn(); });
  }

  /* ================= 2. Sets-Karussell in die Menue-Schublade ================= */
  function injectDrawerSets() {
    var tpl = document.getElementById('br-drawer-sets-tpl');
    if (!tpl) return;
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!nav || nav.dataset.brSets) return;
    nav.dataset.brSets = '1';
    nav.parentNode.insertBefore(tpl.content.cloneNode(true), nav.nextSibling);
    scanSliders();
  }

  /* ================= 3. Weiches Scrollen ================= */
  function initSmoothScroll() {
    if (window.brScrollEnabled === false) return;

    var EASE = window.brScrollEase;
    if (!EASE || EASE <= 0 || EASE > 0.5) EASE = 0.05;

    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!window.matchMedia('(pointer: fine)').matches) return;
    } catch (err) { return; }

    var target = window.scrollY;
    var current = window.scrollY;
    var running = false;
    var lastWheel = 0;

    function maxScroll() {
      var doc = document.documentElement;
      var h = Math.max(doc.scrollHeight, document.body.scrollHeight);
      return Math.max(0, h - window.innerHeight);
    }

    function hasOwnScroll(el) {
      var depth = 0;
      while (el && el.nodeType === 1 && el !== document.body && el !== document.documentElement && depth < 25) {
        var s = window.getComputedStyle(el);
        var oy = s.overflowY;
        if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 2) return true;
        el = el.parentNode;
        depth++;
      }
      return false;
    }

    function tick() {
      var diff = target - current;
      if (Math.abs(diff) < 0.4) {
        current = target;
        window.scrollTo(0, current);
        running = false;
        return;
      }
      current += diff * EASE;
      window.scrollTo(0, current);
      requestAnimationFrame(tick);
    }

    window.addEventListener('wheel', function (e) {
      try {
        if (e.ctrlKey || e.metaKey) return;
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        if (hasOwnScroll(e.target)) return;

        var delta = e.deltaY;
        if (e.deltaMode === 1) delta *= 16;
        else if (e.deltaMode === 2) delta *= window.innerHeight;

        var max = maxScroll();
        if (max <= 0) return;

        if (!running) {
          current = window.scrollY;
          target = current;
        }

        if (delta < 0 && target <= 0) return;
        if (delta > 0 && target >= max - 1) return;

        e.preventDefault();

        target = Math.min(max, Math.max(0, target + delta));
        lastWheel = Date.now();

        if (!running) {
          running = true;
          requestAnimationFrame(tick);
        }
      } catch (err) {
        running = false;
      }
    }, { passive: false });

    window.addEventListener('scroll', function () {
      if (!running && Date.now() - lastWheel > 120) {
        current = target = window.scrollY;
      }
    }, { passive: true });

    function clampToDoc() {
      var max = maxScroll();
      if (target > max) target = max;
      if (current > max) current = max;
    }

    window.addEventListener('resize', clampToDoc);
    window.addEventListener('load', clampToDoc);

    document.addEventListener('keydown', function () {
      if (!running) { current = target = window.scrollY; }
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && !running) { current = target = window.scrollY; }
    });
  }

  /* ================= 4. Abo <-> Bundle-Kopplung ================= */
  /* Regel: Abo = 1 Stueck Nachschub (Rapi-Box aus), Einmalkauf = Bundle sichtbar. */
  function initAboBundleLink() {
    function rapiBox() {
      return document.querySelector('[class*="rapi-bundle-content"]');
    }
    function sealReady() {
      return document.querySelector('.sls-option-container input.sls-option');
    }
    function isSubscription() {
      var checked = document.querySelector('.sls-option-container input.sls-option:checked');
      if (!checked) return null;
      return checked.getAttribute('data-type') === 'subscription';
    }
    function forceQtyOne() {
      document.querySelectorAll('input[name="quantity"], .quantity__input').forEach(function (q) {
        if (String(q.value) !== '1') {
          q.value = '1';
          q.dispatchEvent(new Event('input', { bubbles: true }));
          q.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function apply() {
      if (!sealReady()) return;
      var sub = isSubscription();
      if (sub === null) return;
      var box = rapiBox();
      if (sub) {
        if (box) box.style.display = 'none';
        forceQtyOne();
      } else {
        if (box && box.style.display === 'none') box.style.display = '';
      }
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('sls-option')) {
        setTimeout(apply, 0);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.sls-option-container')) {
        setTimeout(apply, 40);
      }
    });

    var ticks = 0;
    var iv = setInterval(function () {
      apply();
      ticks++;
      if (ticks > 150) clearInterval(iv);
    }, 400);
  }

  /* ================= Start ================= */
  function boot() {
    scanSliders();
    injectDrawerSets();
    initSmoothScroll();
    initAboBundleLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () { scanSliders(); injectDrawerSets(); updateAll(); });
  window.addEventListener('resize', updateAll);
  document.addEventListener('shopify:section:load', function () { scanSliders(); injectDrawerSets(); updateAll(); });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--menu, .menu-drawer-container summary')) {
      setTimeout(updateAll, 60);
      setTimeout(updateAll, 350);
    }
  });
})();